if (!customElements.get('video-robot')) {
  class VideoRobot extends HTMLElement {
    constructor() {
      super();
      this.videoLoaded = false;
      this.observer = null;
    }

    connectedCallback() {
      this.waitForLCP().then(() => {
        this.initObserver();
      });
    }

    waitForLCP() {
      return new Promise(resolve => {
        try {
          const po = new PerformanceObserver(() => {});
          po.observe({ type: 'largest-contentful-paint', buffered: true });
          setTimeout(() => {
            po.disconnect();
            resolve();
          }, 300);
        } catch {
          resolve();
        }
      });
    }

    initObserver() {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.videoLoaded) {
            this.loadVideo();
            this.observer.disconnect();
          }
        });
      }, {
        threshold: 0.5,
        rootMargin: '200px'
      });

      this.observer.observe(this);
    }

    async loadVideo() {
      const tpl = this.querySelector('template');
      if (!tpl) return;

      const fragment = tpl.content.cloneNode(true);
      this.video = fragment.querySelector('video');

      /* 🔑 REQUIRED AUTOPLAY ATTRIBUTES */
      this.video.setAttribute('muted', '');
      this.video.setAttribute('autoplay', '');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('loop', '');
      this.video.muted = true;
      this.video.playsInline = true;

      this.appendChild(fragment);

      const sources = this.video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      this.video.load();
      this.videoLoaded = true;

      /* ✅ Hide image ONLY when video actually plays */
      this.video.addEventListener('playing', () => {
        this.hideFallbackImage();
      }, { once: true });

      try {
        await this.video.play(); // muted autoplay
      } catch {
        // SILENT FAIL — NO BUTTON
      }
    }

    hideFallbackImage() {
      const img = this.querySelector('img[data-fallback]');
      if (!img) return;

      img.style.transition = 'opacity 0.3s ease';
      img.style.opacity = '0';

      setTimeout(() => {
        img.style.display = 'none';
      }, 300);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
    }
  }

  customElements.define('video-robot', VideoRobot);
}